/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulesets1Inputs */

const en_entity_rulesets1 = /** @type {(inputs: Entity_Rulesets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Sets`)
};

const de_entity_rulesets1 = /** @type {(inputs: Entity_Rulesets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeln`)
};

/**
* | output |
* | --- |
* | "Rule Sets" |
*
* @param {Entity_Rulesets1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulesets1 = /** @type {((inputs?: Entity_Rulesets1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulesets1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulesets1(inputs)
	return de_entity_rulesets1(inputs)
});
export { entity_rulesets1 as "entity_ruleSets" }